import { z } from 'zod'
import type { Role } from '@/types'
import { passwordMeetsAllRequirements } from '@/utils/passwordRequirements'

export const loginSchema = z.object({
  email: z.string().email('Insira um formato de e-mail válido.'),
  password: z.string().min(6, 'A senha deve conter no mínimo 6 caracteres.'),
})

export const twoFactorSchema = z.object({
  email: z.string().email('Insira um formato de e-mail válido.'),
  code: z
    .string()
    .transform((value) => value.trim().toUpperCase().replace(/[^A-Z2-9]/g, ''))
    .refine((value) => value.length === 10, { message: 'O código deve ter 10 caracteres alfanuméricos.' }),
})

export const forgotSchema = z.object({
  email: z.string().email('Insira um formato de e-mail válido.'),
})

export const resetSchema = z
  .object({
    token: z.string().min(32, 'Token inválido ou incompleto.'),
    newPassword: z
      .string()
      .min(8, 'A senha deve ter pelo menos 8 caracteres.')
      .refine(passwordMeetsAllRequirements, {
        message:
          'A senha precisa ter letra maiúscula, minúscula, número e caractere especial.',
      }),
    confirmPassword: z.string().min(1, 'Confirme a nova senha.'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'As senhas não coincidem.',
    path: ['confirmPassword'],
  })

export const ROLE_REDIRECTS: Record<Role, string> = {
  admin: '/dashboard',
  manager: '/gestores',
  bdr: '/bdr-panel',
  closer: '/dashboard',
  financeiro: '/financeiro',
  usuario_agrada: '/portal',
  cs: '/cs/carteira',
  pos_venda: '/cs/carteira',
  indicador: '/parceiros/home',
}

export type LoginStep = 'credentials' | 'twoFactor' | 'forgotPassword' | 'resetPassword'
